export const MERCHANTS = [
  "Starbucks",
  "Amazon",
  "Walmart",
  "Target",
  "Best Buy",
  "Costco",
  "Home Depot",
  "Lowe's",
  "Kroger",
  "CVS",
] as const;

export const DESCRIPTIONS_FOR_MERCHANTS = [
  "Coffee shop",
  "Online shopping",
  "Grocery store",
  "Retail store",
  "Electronics store",
  "Warehouse club",
  "Home improvement store",
  "Hardware store",
  "Supermarket",
  "Pharmacy",
] as const;

export const CATEGORY_CODE_MAP: Record<string, string> = {
  "5815": "Entertainment",
  "5814": "Streaming",
  "5735": "Food & Drink",
  "5812": "Dining",
  "5813": "Travel",
  "5816": "Gaming",
  "5817": "Fitness",
  "5818": "Education",
  "5819": "Health",
  "5820": "Shopping",
};

export const LAST_12_MONTHS = [
  "2024-06",
  "2024-07",
  "2024-08",
  "2024-09",
  "2024-10",
  "2024-11",
  "2024-12",
  "2025-01",
  "2025-02",
  "2025-03",
  "2025-04",
  "2025-05",
] as const;

export const MONTH_LABELS_LARGE = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sept",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec",
};

export const MONTH_FULL_NAME = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  "10": "October",
  "11": "November",
  "12": "December",
};

export const MONTH_LABELS_SMALL = {
  "01": "J",
  "02": "F",
  "03": "M",
  "04": "A",
  "05": "M",
  "06": "J",
  "07": "J",
  "08": "A",
  "09": "S",
  "10": "O",
  "11": "N",
  "12": "D",
};
